module.exports = __webpack_public_path__ + "static/media/img-app-setting-new-hires@2x.660a7ed5.png";